export const GetFormattedDate = (text, record) => {
  if (!text) {
    return "";
  }

  const _getMonth = (currMonth) => {
    switch (Number(currMonth)) {
      case 1:
        return "Jan";
      case 2:
        return "Feb";
      case 3:
        return "Mar";
      case 4:
        return "Apr";
      case 5:
        return "May";
      case 6:
        return "Jun";
      case 7:
        return "Jul";
      case 8:
        return "Aug";
      case 9:
        return "Sep";
      case 10:
        return "Oct";
      case 11:
        return "Nov";
      case 12:
        return "Dec";
      default:
        return "";
    }
  };

  // const month = getUTCformattedMonth(date)
  //console.log(text.split("-"))
  const year = text.split("-")[0];
  const day = text.split("-")[2].padStart(2, "0");
  const month = _getMonth(text.split("-")[1]);

  return `${month}-${day}-${year}`;
};

export const GetFormattedDateTime = (text, passTime = false) => {
  if (!text) return "";

  const dateObj = new Date(text);
  if (isNaN(dateObj)) return "";

  const day = String(dateObj.getDate()).padStart(2, "0");

  // Capitalize only the first letter of the month
  const monthRaw = dateObj.toLocaleString("en-US", { month: "short" });
  const month =
    monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1).toLowerCase();

  const year = dateObj.getFullYear();

  let formatted = `${month}-${day}-${year}`;

  if (passTime === true) {
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format
    formatted += ` ${hours}:${minutes} ${ampm}`;
  }

  return formatted;
};

export const GetSpacedSpan = (text) => {
  if (!text) return "";
  return <div className="givePadding">{text}</div>;
};
